import { buildDashboardPageURL } from '@crm/components/dashboard/buildDashboardPageURL'
import { buildPropertiesPageURL } from '@crm/components/properties/buildPropertiesPageURL'
import { buildContactsPageURL } from '@crm/components/contacts/buildContactsPageURL'
import { buildLeadsPageURL } from '@crm/components/leads/buildLeadsPageURL'
import { buildReportsPageURL } from '@crm/components/reports/buildReportsPageURL'
import { buildProspectorPageURL } from '@crm/components/prospector/buildProspectorPageURL'
import { buildTrustPageURL } from '@crm/components/trust/buildTrustPageURL'
import { buildTasksPageURL } from '@crm/components/tasks/buildTasksPageURL'
import { buildOfficePageURL } from '@crm/components/office/buildOfficePageURL'
import { buildCMSPageURL } from '@crm/components/cms/buildCMSPageURL'

export const NAV_MENU = {
  DASHBOARD: 'Dashboard',
  PROPERTIES: 'Properties',
  CONTACTS: 'Contacts',
  LEADS: 'Leads',
  REPORTS: 'Reports',
  PROSPECTOR: 'Prospector',
  TRUST: 'Trust',
  TASKS: 'Tasks',
  MYOFFICE: 'My Office',
  CMS: 'Website',
} as const

// This gives you a union type like: 'Dashboard' | 'Properties' | ...
export type NavTitle = (typeof NAV_MENU)[keyof typeof NAV_MENU]

// this key is to check RoutesPrivilege on configuration api
export const RouteToPrivilegeKey: Record<string, string> = {
  [buildDashboardPageURL()]: 'dashboard',
  [buildPropertiesPageURL()]: 'properties',
  [buildContactsPageURL()]: 'contacts',
  [buildLeadsPageURL()]: 'leadCapture',
  [buildReportsPageURL()]: 'reports',
  [buildProspectorPageURL()]: 'prospector',
  [buildTrustPageURL()]: 'salesTrust',
  [buildTasksPageURL()]: 'tasks',
  [buildOfficePageURL()]: 'office',
  [buildCMSPageURL()]: 'cms',
}
